var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ya-share2 text-center",attrs:{"data-services":"vkontakte,odnoklassniki,twitter","data-url":_vm.link}})}
var staticRenderFns = []

export { render, staticRenderFns }